import type { LocaleType } from "./en";

export const deLocale: LocaleType = {
  welcome: {
    title: "Willkommen bei Vomi",
    subtitle: "Bitte geben Sie Ihren Anzeigenamen ein, um fortzufahren",
    displayNameLabel: "Anzeigename",
    displayNamePlaceholder: "Geben Sie Ihren Namen oder Alias ein",
    continueButton: "Weiter",
    logout: "Abmelden",
    footer: "Vomi Business Portal • Sicherer Zugang",
    validation: {
      nameRequired: "Bitte geben Sie Ihren Anzeigenamen ein",
    },
    success: {
      welcomeMessage:
        "Willkommen {name}! App-Funktionen werden hier hinzugefügt.",
    },
  },
  nativeLogin: {
    title: "Anmeldung",
    emailLabel: "E-Mail",
    passwordLabel: "Passwort",
    submit: "Anmelden",
    invalidCredentials: "Ungültige E-Mail oder Passwort.",
    otpRequired: "Dieses Konto benötigt einen zusätzlichen Verifizierungsschritt, der hier nicht unterstützt wird. Bitte melden Sie sich über den Browser an.",
    genericError: "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    browserFallback: "Über den Browser anmelden",
  },
  toast: {
    error: "Fehler",
    success: "Erfolgreich",
    defaultError: "Ein Fehler ist aufgetreten",
    tracingIdPrefix: "Fehler-ID",
    copyErrorId: "Fehler-ID kopieren",
    errorIdCopied: "Fehler-ID wurde kopiert.",
    errorIdCopyFailed: "Kopieren fehlgeschlagen. Bitte markieren und kopieren Sie die ID manuell.",
  },
  common: {
    loading: "Lädt...",
    error: "Ein Fehler ist aufgetreten",
    notAvailable: "Nicht verfügbar",
    retry: "Erneut versuchen",
    back: "Zurück",
    cancel: "Abbrechen",
    save: "Speichern",
    close: "Schließen",
    upload: "Hochladen",
    remove: "Entfernen",
    select: "Auswählen",
    edit: "Bearbeiten",
    yes: "Ja",
    no: "Nein",
    documentSaved: "Dokument gespeichert",
    scrollLeft: "Nach links scrollen",
    scrollRight: "Nach rechts scrollen",
    documentOpenError: "Dokument gespeichert, konnte aber nicht geöffnet werden.",
  },
  nav: {
    home: "Start",
    add: "Mitarbeiter",
    hours: "Stunden",
    payroll: "Gehalt",
    reports: "Berichte",
  },
  support: {
    buttonLabel: "Hilfe und Feedback",
    title: "Teilen Sie Ihre Meinung",
    requiredHint: "Pflichtfelder sind mit einem Sternchen gekennzeichnet.",
    typeLabel: "Wählen Sie die Art des Feedbacks",
    typePlaceholder: "Auswählen",
    textLabel: "Ihre Nachricht",
    textPlaceholder: "Schreiben Sie hier Ihre Nachricht",
    submit: "Senden",
    types: {
      QUESTION: "Stellen Sie eine Frage",
      COMMENT: "Hinterlassen Sie einen Kommentar",
      BUG: "Melden Sie einen Fehler",
      IMPROVEMENT: "Schlagen Sie eine Verbesserung vor",
    },
    validation: {
      typeRequired: "Wählen Sie die Art des Feedbacks.",
      textRequired: "Geben Sie den Nachrichtentext ein.",
    },
    success: "Ihre Nachricht wurde erfolgreich gesendet.",
    error: "Die Nachricht kann derzeit nicht gesendet werden. Bitte versuchen Sie es erneut.",
  },
  profile: {
    title: "Profil",
    logout: "Abmelden",
    accountSettings: "KONTOEINSTELLUNGEN",
    clientSettings: "KUNDENEINSTELLUNGEN",
    email: "E-Mail",
    phone: "Telefon",
    company: "Firma",
    preferences: "PRÄFERENZEN",
    language: "Sprache",
    signature: "Signatur",
    addSignature: "Signatur hinzufügen",
    notifications: "Benachrichtigungen",
    manageNotifications: "Verwalten Sie Ihre Benachrichtigungseinstellungen",
    assignedEmployees: "ZUSTÄNDIGE MITARBEITER",
    assignedEmployeeFinanceAndVat: "Finanzen und Mehrwertsteuer",
    assignedEmployeeSalaryCalculation: "Lohnabrechnung",
    assignedEmployeeFinalReport: "Jahresabschlüsse",
    assignedEmployeeNotAssigned: "Es ist noch kein Mitarbeiter zugewiesen.",
    legal: "Rechtliche Dokumente",
    legalOpenExternal: "Im Browser öffnen",
    legalDocs: {
      uvjeti: "Nutzungsbedingungen",
      privatnost: "Datenschutzerklärung",
      kolacici: "Cookie-Richtlinie",
      podizvrsitelji: "Liste der Unterauftragsverarbeiter",
      prihvatljivo: "Richtlinie zur zulässigen Nutzung",
      sigurnost: "Sicherheit und Meldung von Vorfällen",
      impressum: "Anbieterinformationen",
    },
    security: "Sicherheit",
    securityDescription: "Passwort, Zwei-Faktor-Authentifizierung",
    annualHolidays: "Jährlicher Urlaub",
    settingsAnnualHolidays: "Einstellungen für den jährlichen Urlaub",
    profilePicture: "Profilbild",
    supportedFormats: "PNG, JPG oder GIF (max. 5MB)",
    currentProfilePicture: "Aktuelles Profilbild",
    uploadedOn: "Hochgeladen am",
    uploadNew: "Neu hochladen",
    editEmail: "E-Mail bearbeiten",
    emailAddress: "E-Mail-Adresse",
    emailPlaceholder: "Geben Sie Ihre E-Mail-Adresse ein",
    editPhone: "Telefonnummer bearbeiten",
    phoneNumber: "Telefonnummer",
    phonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
    editCompany: "Firma bearbeiten",
    companyName: "Firmenname",
    companyPlaceholder: "Geben Sie Ihren Firmennamen ein",
    selectLanguage: "Sprache auswählen",
    preferredLanguage: "Bevorzugte Sprache",
    languagePlaceholder: "Wählen Sie eine Sprache",
    electronicSignature: "Elektronische Signatur",
    drawSignature: "Zeichnen Sie Ihre Signatur in das Feld unten",
    clearSignature: "Löschen",
    useTypedSignature: "Getippte Signatur verwenden",
    typeSignature: "Geben Sie Ihre Signatur ein",
    typeSignaturePlaceholder: "Geben Sie Ihre Signatur ein",
    saveSignature: "Signatur speichern",
    selectHolidayDates: "Wählen Sie Ihre jährlichen Urlaubstermine",
    selectedDates: "Ausgewählte Termine",
    noDatesSelected: "Keine Termine ausgewählt",
    moreDates: "weitere Termine",
    saveHolidays: "Urlaub speichern",
    holidaysDescription: "Übersicht der konfigurierten Feiertage.",
    holidayCountry: "Feiertagsland",
    holidayCountryCroatia: "Kroatien",
    holidayCountryGermany: "Deutschland",
    notificationSettings: "Benachrichtigungseinstellungen",
    notificationMessage: "Die Verwaltung von Benachrichtigungen wird in Kürze verfügbar sein.",
    securitySettings: "Sicherheitseinstellungen",
    securityMessage: "Die Verwaltung von Sicherheitseinstellungen wird in Kürze verfügbar sein.",
    signatureSaved: "Gespeichert",
    currentSignature: "Aktuelle Signatur",
    updateSignature: "Signatur aktualisieren",
    fileTooLarge: "Die Dateigröße überschreitet das Limit von 5MB",
    invalidFileType: "Bitte laden Sie ein gültiges Bild hoch (JPG, PNG, GIF, WebP)",
    uploadFailed: "Fehler beim Lesen der Datei. Bitte versuchen Sie es erneut.",
    contactsTitle: "Kontakte",
    noContacts: "Keine Kontakte",
    primaryContact: "Primär",
    accountDetails: "Kontodetails",
    firstName: "Vorname",
    lastName: "Nachname",
    companyDetails: "Firmendetails",
    noCompanyData: "Keine Firmendaten",
    businessType: "Unternehmensart",
    messages: {
      imageSaved: "Profilbild erfolgreich gespeichert",
      imageDeleted: "Profilbild gelöscht",
      signatureSaved: "Signatur erfolgreich gespeichert",
    },
  },
  termsGate: {
    title: "Nutzungsbedingungen",
    text: "Um die Anwendung weiter zu nutzen, müssen Sie die aktuellen Nutzungsbedingungen akzeptieren (Version {version}).",
    open: "Nutzungsbedingungen öffnen",
    agree: "Ich habe die Nutzungsbedingungen gelesen und akzeptiere sie.",
    continue: "Weiter",
  },
  languages: {
    english: "Englisch",
    croatian: "Kroatisch",
    german: "Deutsch",
  },
  months: {
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember",
  },
  days: {
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",
    mon: "Mo",
    tue: "Di",
    wed: "Mi",
    thu: "Do",
    fri: "Fr",
    sat: "Sa",
    sun: "So",
  },
  validation: {
    required: "Dieses Feld ist erforderlich",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    invalidPhone: "Bitte geben Sie eine gültige Telefonnummer ein",
    minLength: "Muss mindestens {length} Zeichen lang sein",
    maxLength: "Muss weniger als {length} Zeichen lang sein",
  },
  clientEmployees: {
    title: "Aktuelle Mitarbeiter",
    searchPlaceholder: "Mitarbeiter suchen...",
    addEmployee: "Mitarbeiter hinzufügen",
    editEmployee: "Mitarbeiter bearbeiten",
    confirmCancelMessage: "Sind Sie sicher, dass Sie abbrechen möchten? Alle eingegebenen Daten gehen verloren.",
    noEmployees: "Keine Mitarbeiter gefunden",
    firstName: "Vorname",
    lastName: "Nachname",
    oib: "OIB",
    sortPlaceholder: "Sortieren nach…",
    sortDirectionLabel: "Sortierrichtung umschalten",
    status: "Status",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    statusPending: "Ausstehend",
    note: "Notiz",
    noteReminder: "Erinnerung",
    pendingMessage: "Die Anmeldung wird von VOMI bearbeitet. Der Vertrag wird nach Abschluss verfügbar sein.",
    street: "Straße",
    houseNumber: "Hausnummer",
    city: "Stadt",
    postalCode: "Postleitzahl",
    country: "Land",
    addressAddition: "Adresszusatz",
    address: "Adresse",
    deactivate: "Deaktivieren",
    terminate: "Abmeldung",
    terminateEmployee: "Mitarbeiter abmelden",
    archive: "Archivieren",
    showInactive: "Inaktive anzeigen",
    filterActive: "Aktiv",
    filterPending: "In Vorbereitung",
    filterInactive: "Abgemeldet",
    noActiveEmployees: "Keine aktiven Mitarbeiter",
    noPendingEmployees: "Keine Mitarbeiter in Vorbereitung",
    noInactiveEmployees: "Keine abgemeldeten Mitarbeiter",
    noSearchResults: "Keine Suchergebnisse",
    deactivateConfirmTitle: "Mitarbeiter deaktivieren",
    deactivateConfirmMessage:
      "Sind Sie sicher, dass Sie diesen Mitarbeiter deaktivieren möchten?",
    archiveConfirmTitle: "Mitarbeiter archivieren",
    archiveConfirmMessage:
      "Sind Sie sicher, dass Sie diesen Mitarbeiter archivieren möchten?",
    formValidation: {
      requiredHint: "Pflichtfelder sind mit einem Sternchen (*) gekennzeichnet.",
      fixErrors: "Fortfahren nicht möglich — bitte korrigieren Sie die rot markierten Felder.",
      firstNameRequired: "Geben Sie den Vornamen ein.",
      lastNameRequired: "Geben Sie den Nachnamen ein.",
      streetRequired: "Geben Sie die Straße ein.",
      houseNumberRequired: "Geben Sie die Hausnummer ein.",
      cityRequired: "Geben Sie die Stadt ein.",
      postalCodeRequired: "Geben Sie die Postleitzahl ein.",
      countryRequired: "Geben Sie das Land ein.",
      oibRequired: "Geben Sie die OIB ein.",
      oibInvalid: "Geben Sie die OIB im richtigen Format ein (11 Ziffern).",
    },
    onboarding: {
      title: "Mitarbeiter-Onboarding",
      subtitle: "Neue Mitarbeiter einrichten und Dokumentation verwalten",
      requiredDocuments: "Erforderliche Dokumente",
      documentsLabel: "Dokumente",
      formTitle: "Mitarbeiterinformationen",
      documents: {
        personalId: "Personalausweis und Grunddaten",
        personalIdDesc: "Persönliche Dokumente und Grundinformationen",
        taxCard: "Steuerkarte",
        taxCardDesc: "Steuerunterlagen und Karten",
        iban: "IBAN des regulären und geschützten Kontos",
        ibanDesc: "Bankkonten für Gehaltszahlung",
        workRecord: "Elektronischer Arbeitsnachweis",
        workRecordDesc: "Digitaler Nachweis der Berufserfahrung",
        workPermit: "Arbeitserlaubnis",
        workPermitDesc: "Scan oder Foto der gültigen Arbeitserlaubnis",
        upload: "Hochladen",
        uploadHint: "PDF, JPG oder PNG, max. 5MB",
        uploaded: "Hochgeladen",
        required: "Erforderlich",
        optional: "Optional",
        deadlineDays: "Frist: 5 Tage",
        fileTooLarge: "Datei zu groß (max. 5MB)",
        uploadSuccess: "Dokumente erfolgreich gesendet",
        requiredDocsMessage:
          "Personalausweis hochladen",
        pendingDocs: "Fehlende Dokumente",
        sendDocuments: "Dokumente senden",
        deadlineRemaining: "{documents} — noch {days} Tage zum Hochladen",
        deadlineRemainingOne: "{documents} — noch {days} Tag zum Hochladen",
        deadlineExpired: "{documents} — Frist zum Hochladen ist abgelaufen!",
        ibanChoose: "Wie möchten Sie die IBAN hinzufügen?",
        ibanUploadFile: "Dokument hochladen",
        ibanEnterManually: "IBAN manuell eingeben",
        ibanPlaceholder: "HR1234567890123456789",
        ibanManuallyEntered: "IBAN manuell eingegeben",
        ibanValidation: "Geben Sie eine gültige IBAN ein (HR + 19 Ziffern)",
      },
      actions: {
        chooseAction: "Aktion auswählen",
        change: "Änderung",
        deactivate: "Deaktivieren",
        terminate: "Abmeldung",
        archive: "Archivieren",
      },
    },
    actions: {
      header: "Aktionen",
      edit: "Bearbeiten",
      deactivate: "Deaktivieren",
      archive: "Archivieren",
    },
    contract: {
      title: "Arbeitsvertrag",
      contractStartDate: "Vertragsbeginn",
      jobTitle: "Berufsbezeichnung",
      jobTitlePlaceholder: "z.B. Buchhalter",
      contractType: "Vertragsart",
      fullTime: "Vollzeit",
      partTime: "Teilzeit",
      workingHours: "Wochenstunden",
      workingHoursPlaceholder: "z.B. 20 oder 20:00",
      scheduleType: "Arbeitszeitregelung",
      scheduleFixed: "Fest",
      scheduleAgreement: "Nach Vereinbarung",
      scheduleShift: "Schichtarbeit",
      shift: {
        typeLabel: "Art der Schichtarbeit",
        daily: "Tagesschichten",
        dailyHint: "Die Arbeitszeit wird je Tag festgelegt",
        weekly: "Wochenschichten",
        weeklyHint: "Schichten wechseln automatisch wöchentlich",
        dailySectionTitle: "Arbeitszeit je Tag",
        days: {
          MONDAY: "Mo",
          TUESDAY: "Di",
          WEDNESDAY: "Mi",
          THURSDAY: "Do",
          FRIDAY: "Fr",
          SATURDAY: "Sa",
          SUNDAY: "So",
        },
        start: "Beginn",
        end: "Ende",
        dayOff: "frei",
        workingDay: "Arbeitstag",
        freeDay: "Freier Tag",
        copyMonday: "Montag auf Arbeitstage übertragen",
        fundOver: "{diff} über der vereinbarten Arbeitszeit ({fund})",
        fundUnder: "{diff} unter der vereinbarten Arbeitszeit ({fund})",
        weeklyTotal: "Wöchentlich gesamt",
        rotationSectionTitle: "Schichten in der Rotation",
        shiftName: "Schichtname",
        unnamedShift: "(ohne Namen)",
        newShiftName: "{n}. Schicht",
        addShift: "Schicht hinzufügen",
        removeShift: "Schicht entfernen",
        workingDays: "Arbeitstage pro Woche",
        workingDaysHint: "Jede Schicht hat eigene Arbeitstage — z. B. eine Woche 5, die nächste 6 Tage. Die Schaltfläche 5 oder 6 Tage setzt eine Vorgabe (bei 6 Tagen ein kürzerer Samstag); danach Tage und Zeiten bearbeiten. Jede Woche muss die vereinbarte Arbeitszeit ergeben.",
        firstWeekShift: "Schicht in der ersten Vertragswoche",
        firstWeekShiftHint: "Die Rotation zählt ab der Woche des Vertragsbeginns und läuft der Reihe nach durch alle Schichten.",
        previewTitle: "Rotationsvorschau (erste 6 Wochen)",
        previewWeek: "{n}. Woche",
        previewNeedsStartDate: "Die Rotationsvorschau wird angezeigt, sobald das Vertragsbeginndatum gewählt ist.",
        perShiftWeekly: "Wöchentlich je Schicht",
        contractedFund: "Vereinbarte Stunden",
        validation: {
          dailyNoDays: "Für Tagesschichten muss mindestens ein Arbeitstag ausgewählt sein.",
          invalidTime: "Schichtbeginn und -ende müssen im Format HH:MM sein.",
          sameStartEnd: "Schichtbeginn und Schichtende dürfen nicht gleich sein.",
          weeklyMinTwoShifts: "Für Wochenschichten sind mindestens zwei Schichten erforderlich.",
          weeklyFirstShiftRequired: "Wählen Sie die Schicht für die erste Vertragswoche.",
          weeklyShiftNameRequired: "Der Schichtname ist erforderlich.",
          weeklyNoDays: "Die Schicht „{name}“ muss mindestens einen Arbeitstag haben.",
          weeklyUnequalShifts: "Alle Schichten in der Rotation müssen pro Woche gleich lang sein.",
          dailyFundMismatch: "Die Wochensumme muss den vereinbarten {expected} entsprechen (eingegeben: {total}).",
          weeklyFundMismatch: "Die Wochenstunden je Schicht müssen den vereinbarten {expected} entsprechen (eingegeben: {total}).",
        },
      },
      weeklyScheduleType: "Wochenplan",
      fiveDaySchedule: "Fünftagewoche (Mo-Fr)",
      sixDaySchedule: "Sechstagewoche (Mo-Sa)",
      sixDayScheduleHint: "Samstag zählt als regulärer Arbeitstag (keine Überstunden).",
      contractDuration: "Vertragsdauer",
      durationIndefinite: "Unbefristet",
      durationDefinite: "Befristet",
      reason: "Grund für Befristung",
      reasonPlaceholder: "z.B. Elternzeitvertretung",
      vacationDays: "Jahresurlaub (Tage)",
      vacationDaysPlaceholder: "min. 20",
      proportionalVacationDays: "Anteiliger Jahresurlaub",
      proportionalVacationDaysNote: "Ein befristet beschäftigter Arbeitnehmer hat Anspruch auf einen anteiligen Jahresurlaub, der sich nach der Dauer des Arbeitsverhältnisses berechnet.",
      salaryType: "Gehaltsart",
      salaryTypeBruto: "Brutto",
      salaryTypeNeto: "Netto",
      monthlyGrossSalary: "Monatliches Bruttogehalt (EUR)",
      salaryPlaceholder: "Bruttogehalt",
      salaryNote: "Das Bruttogehalt ist nicht der endgültige Kostenaufwand — der Krankenversicherungsbeitrag wird zusätzlich berechnet.",
      minimumGrossSalaryNote: "Das Mindestbruttogehalt beträgt {amount} (Wert wird aus den Systemeinstellungen übernommen).",
      minimumGrossSalaryPartTimeNote: "Bei Teilzeit richtet sich das Mindestbruttogehalt anteilig nach den Wochenstunden: {percent} % von {full} = {amount}.",
      desiredNetSalary: "Gewünschtes Nettogehalt (EUR)",
      desiredNetSalaryPlaceholder: "min. {amount}",
      desiredNetSalaryPartTimeNote: "Bei Teilzeit richtet sich das Mindestnettogehalt anteilig nach den Wochenstunden: {percent} % von {full} € = {amount} €.",
      desiredNetSalaryNote: "Der endgültige Nettogehaltsbetrag hängt von den Steuervorschriften der Wohngemeinde des Arbeitnehmers ab und kann eine Korrektur erfordern. Vomi erstellt den Arbeitsvertrag mit dem entsprechenden Bruttobetrag unter Berücksichtigung des eingegebenen gewünschten Nettobetrags.",
      allowances: "Steuerfreie Gehaltszulagen (optional)",
      transportCost: "Fahrtkosten (EUR/Mo.)",
      transportCostNote: "Bis zur tatsächlichen monatlichen Fahrkarte",
      mealAllowance: "Verpflegungszuschuss (EUR/Mo.)",
      mealAllowanceNote: "Bis {limit} EUR monatlich",
      performanceBonus: "Leistungsprämie (EUR/Mo.)",
      performanceBonusNote: "Bis {limit} EUR jährlich",
      occasionalBonus: "Sonderprämie (EUR/Mo.)",
      occasionalBonusNote: "Bis {limit} EUR jährlich",
      mealAllowanceWarn: "Warnung: Empfohlener Höchstbetrag für Verpflegungszuschuss ist {limit} EUR monatlich",
      performanceBonusWarn: "Warnung: Empfohlener Höchstbetrag für Leistungsprämie ist {limit} EUR jährlich",
      occasionalBonusWarn: "Warnung: Empfohlener Höchstbetrag für Sonderprämie ist {limit} EUR jährlich",
      workingHoursFormat: "Wöchentliche Teilzeitarbeit in Stunden oder im Format HH:MM (00:01–39:59)",
      workingHoursInvalid: "Wöchentliche Arbeitszeit im Format HH:MM eingeben (00:01–39:59)",
      contractStartDateRequired: "Geben Sie das Datum des Arbeitsbeginns ein.",
      contractStartDateInvalid: "Der Vertragsbeginn muss heute oder später sein (nach 14 Uhr erst ab morgen), maximal 30 Tage im Voraus.",
      contractStartDateHint: "Eine Anmeldung mit dem heutigen Datum ist nur bis 14:00 Uhr möglich — danach ist der früheste verfügbare Termin morgen.",
      jobTitleRequired: "Geben Sie die Berufsbezeichnung ein.",
      workingHoursRequired: "Geben Sie die Wochenstunden für die Teilzeitbeschäftigung ein.",
      reasonRequired: "Geben Sie den Grund für den befristeten Vertrag ein.",
      vacationDaysRequired: "Geben Sie die Anzahl der Urlaubstage ein.",
      vacationDaysMin: "Mindestens {min} Urlaubstage.",
      salaryRequired: "Geben Sie das Bruttogehalt ein.",
      salaryPositive: "Betrag muss größer als 0 sein.",
      salaryBelowMinimum: "Das Bruttogehalt für Vollzeitbeschäftigung darf nicht weniger als {amount} betragen.",
      salaryBelowPartTimeMinimum: "Das Bruttogehalt für die eingegebenen Teilzeitstunden darf nicht weniger als {amount} betragen.",
      desiredNetSalaryRequired: "Das gewünschte Nettogehalt ist erforderlich.",
      desiredNetSalaryBelowMinimum: "Das Mindestnettogehalt beträgt {amount} €.",
      amountNotNegative: "Der Betrag darf nicht negativ sein.",
      notDefined: "Vertrag nicht definiert",
      editDisabled: "Vertragsbearbeitung wird in einem zukünftigen Update verfügbar sein (Nachtrag)",
      editTitle: "Vertrag bearbeiten",
      changesRequireAmendment: "Diese Änderung erfordert einen Vertragsanhang",
      changesRequireNewContract: "Diese Änderung erfordert einen neuen Arbeitsvertrag",
      changeRejected: "Diese Änderung ist nicht zulässig. Die Vertragsdauer kann nicht von Befristet zu Unbefristet geändert werden.",
      contractTypeLockedHint: "Vertragsart ist wegen Nebentätigkeit auf Teilzeit gesperrt",
      updateSuccessEdit: "Vertrag aktualisiert",
      updateSuccessAnnex: "Vertragsanhang erstellt. PDF wird generiert.",
      updateSuccessNewContract: "Neuer Arbeitsvertrag erstellt. PDF wird generiert.",
      updateError: "Fehler beim Aktualisieren des Vertrags",
      annexForSigningTitle: "Anhang zur Unterschrift",
      newContractForSigningTitle: "Neuer Vertrag zur Unterschrift",
      newContractDownload: "Neuen Vertrag herunterladen",
      newContractConfirmAction: "Neuen Vertrag unterschreiben",
      newContractConfirmedBadge: "Neuer Vertrag unterschrieben",
      annexForSigningHint: "Geben Sie das Dokument dem Mitarbeiter zur Unterschrift und übermitteln Sie es an die Buchhaltung oder archivieren Sie es lokal.",
      annexConfirmAction: "Anhang unterschreiben",
      annexConfirmedBadge: "Anhang unterschrieben",
      annexNotReadyYet: "Der Anhang ist noch nicht bereit. Sie werden benachrichtigt, sobald VOMI das Dokument vorbereitet hat.",
      annexDownload: "Anhang herunterladen",
      annexConfirmSuccess: "Anhang erfolgreich bestätigt.",
      annexConfirmError: "Fehler beim Bestätigen des Anhangs.",
      history: "Vertragshistorie",
      noHistory: "Keine früheren Vertragsversionen",
      historyVersionNew: "Originalvertrag",
      historyVersionEdit: "Vertragsänderung",
      annexAppliedBadge: "Mit Anhang",
      newContractAppliedBadge: "Neuer Vertrag",
      historyChangeDate: "Änderungsdatum",
      historyDetailsTitle: "Vertragsdetails",
      historyViewDetails: "Details anzeigen",
      downloadContract: "Vertrag herunterladen",
      isForeigner: "Ausländer",
      firstEmploymentReliefQuestion: "Nutzung der Beitragsentlastung (erste Beschäftigung)",
      firstEmploymentReliefHint: "Voraussetzung: unbefristeter Vertrag.",
      citizenshipQuestion: "Staatsangehörigkeit",
      citizenshipEu: "EU / EWR / Schweiz",
      citizenshipThirdCountry: "Drittstaat",
      workPermitQuestion: "Verfügt die Person über eine gültige, von Ihrem Unternehmen erwirkte Arbeitserlaubnis?",
      workPermitHasPermit: "Die Person hat eine gültige Arbeitserlaubnis",
      workPermitNoPermit: "Die Person hat keine Arbeitserlaubnis",
      workPermitRequired: "Das Anhängen der Arbeitserlaubnis ist erforderlich.",
      workPermitBlockedTitle: "Anmeldung nicht möglich",
      workPermitBlockedMessage: "Der Arbeitnehmer kann ohne gültige Arbeitserlaubnis nicht angemeldet werden. Wenden Sie sich an Vomi d.o.o., um die Voraussetzungen für Arbeitgeber und Arbeitnehmer zu prüfen. Vomi d.o.o. kann Ihnen den Service der Beantragung der Arbeitserlaubnis anbieten.",
      workPermitUploadAfterApproval: "Die Arbeitserlaubnis wird angefordert, sobald ein Master diese Anfrage genehmigt.",
      isAdditionalWork: "Zusätzliche Arbeit",
      additionalWorkMaxHours: "Zusätzliche Arbeit darf höchstens 8 Stunden pro Woche betragen.",
      worksSaturday: "Arbeitet samstags",
      worksSaturdayRequiresSixDay: "Samstagsarbeit ist nur bei einer Sechstagewoche möglich.",
      worksSaturdayRequiresFullTimeFixed: "Samstagsarbeit ist nur bei Vollzeit mit festem Arbeitsplan möglich.",
      worksSaturdayLegacy: "Übernommen aus einem früheren Vertrag. Sie bleibt bestehen, kann aber nicht erneut aktiviert werden.",
      worksSaturdayAdditionalWork: "Bei zusätzlicher Arbeit kann Samstagsarbeit nach Bedarf aktiviert werden. Der Samstag zählt zum wöchentlichen Höchstumfang von 8 Stunden, und der Arbeitsplan ist dann \"Nach Vereinbarung\".",
      agreementScheduleSaturdayHint: "Bei einem Arbeitsplan nach Vereinbarung werden die Arbeitstage (einschließlich Samstag) manuell in der Arbeitszeiterfassung eingetragen.",
      passportNumber: "Passnummer",
      passportNumberPlaceholder: "z.B. AB1234567",
      passportNumberRequired: "Geben Sie die Passnummer ein (erforderlich für ausländische Mitarbeiter).",
      probationPeriod: "Probezeit (Monate)",
      probationPeriodRange: "Die Probezeit muss zwischen 1 und 6 Monaten liegen. Dauert das Arbeitsverhältnis weniger als einen Monat, lassen Sie dieses Feld leer.",
      probationPeriodExceedsContract: "Die Probezeit darf nicht länger sein als die Laufzeit des befristeten Vertrags.",
      probationPeriodShortContractHint: "Dauert das Arbeitsverhältnis weniger als einen Monat, lassen Sie dieses Feld leer.",
      probationPeriodShortContract: "Das Arbeitsverhältnis dauert weniger als einen Monat — lassen Sie dieses Feld leer.",
      workLocation: "Arbeitsort",
      workLocationPlaceholder: "z.B. Zagreb",
      contractEndDate: "Vertragsendedatum",
      contractEndDateRequired: "Geben Sie das Enddatum des befristeten Vertrags ein.",
      workStartTime: "Arbeitsbeginn",
      workEndTime: "Arbeitsende",
      workStartTimePlaceholder: "08:00",
      workEndTimePlaceholder: "16:00",
      workEndTimeAutoCalculated: "Wird automatisch aus Arbeitsbeginn und Wochenstunden berechnet.",
      workEndTimeAutoCalculatedMismatch: "Arbeitsende muss {time} sein (Arbeitsbeginn + Wochenstunden / 5).",
      workTimeFormat: "Format HH:MM (00:00–23:59)",
      workTimeInvalid: "Zeit im Format HH:MM eingeben (00:00–23:59).",
      workEndAfterStart: "Arbeitsende muss nach dem Arbeitsbeginn liegen.",
      workStartTimeRequired: "Dieses Feld ist bei fester Arbeitszeit erforderlich.",
      workEndTimeRequired: "Dieses Feld ist bei fester Arbeitszeit erforderlich.",
      fixedScheduleHint: "Bei fester Arbeitszeit müssen alle zugehörigen, mit Sternchen markierten Felder ausgefüllt werden (Arbeitsbeginn und -ende).",
      workTimeFullTimeSpanInvalid: "Bei Vollzeitbeschäftigung muss die Arbeitszeitspanne {hours}h betragen.",
      partTimeSixDayFixedDisabled: "Bei Teilzeit mit Samstagsarbeit ist kein fester Zeitplan möglich. Verwenden Sie 'Nach Vereinbarung' und geben Sie die Stunden manuell pro Tag ein.",
      workingHoursNotDivisibleBy5: "Die Wochenstunden sind nicht durch 5 (Arbeitstage) teilbar. Verwenden Sie 'Nach Vereinbarung' statt 'Fest' und geben Sie die Stunden manuell pro Tag ein.",
      downloadDisabled: "Die Vertragsdokumenterstellung wird in einem zukünftigen Update verfügbar sein",
      documentSection: "Vertragsdokument",
      notReadyYet: "Das Dokument ist noch nicht bereit. Sie werden benachrichtigt, sobald VOMI den Vertrag vorbereitet hat.",
      confirmDocument: "Dokument unterschreiben",
      signatureRequired: "Richten Sie eine digitale Signatur in Ihrem Profil ein, um das Dokument zu bestätigen.",
      confirmHint: "Übergeben Sie das Dokument dem Mitarbeiter zur Unterschrift und leiten Sie es an die Buchhaltung weiter oder archivieren Sie es selbst.",
      confirmedBadge: "Unterschrieben",
      downloadError: "Fehler beim Herunterladen des Dokuments.",
      confirmSuccess: "Das Dokument wurde bestätigt.",
      confirmError: "Fehler beim Bestätigen des Dokuments.",
      alreadyConfirmed: "Das Dokument wurde bereits bestätigt.",
    },
    detail: {
      personalData: "Persönliche Daten",
      tabs: {
        overview: "Übersicht",
        contract: "Vertrag",
        absences: "Abwesenheiten",
        hours: "Arbeitszeiten",
        nonTaxable: "Steuerfreie Zuwendungen",
      },
      absencesPlaceholder: "Abwesenheiten — bald verfügbar",
      absencesSubtext: "Krankmeldung und Jahresurlaub",
      hoursPlaceholder: "Arbeitszeiten — bald verfügbar",
      hoursSubtext: "Arbeitszeiterfassung",
      salarySection: "Gehalt und Zulagen",
      workTime: {
        title: "Arbeitszeiten",
        periodLabel: "Zeitraum",
        empty: "Keine Daten für den ausgewählten Zeitraum",
        pendingMessage: "Der Mitarbeiter wurde noch nicht von VOMI bestätigt. Arbeitszeiten werden nach Bestätigung der Anmeldung verfügbar sein.",
        noDays: "Für den ausgewählten Monat gibt es keine Tageseinträge — der Mitarbeiter war nicht in der Arbeitszeiterfassung (z. B. Langzeitabwesenheit).",
        lockedMessage: "Arbeitszeiten und das Datum der Lohnabrechnung können nicht bearbeitet werden, da die Lohnabrechnung in Bearbeitung oder abgeschlossen ist. Für Änderungen wenden Sie sich bitte an die Vomi d.o.o.",
        loading: "Arbeitszeiten werden geladen...",
        error: "Fehler beim Laden der Arbeitszeiten",
        retry: "Erneut versuchen",
        plannedShiftHint: "Vertragliche Arbeitszeit — Tag nicht manuell erfasst",
        shiftWeeks: {
          title: "Schichten nach Wochen",
          hint: "Die Wochen folgen der Rotation aus dem Vertrag. Für die aktuelle und kommende Wochen können Sie eine andere Schicht wählen — sie gilt nur für diese Woche.",
          changed: "Manuell geändert",
          resetToRotation: "Zurück zur Rotation",
          saved: "Schicht für die Woche gespeichert",
        },
        dayType: {
          REGULAR: "Arbeitstag",
          WEEKEND: "Wochenende",
          HOLIDAY: "Feiertag",
          VACATION: "Jahresurlaub",
          SICK_LEAVE: "Krankmeldung",
        },
        columns: {
          date: "Datum",
          type: "Typ",
          start: "Beginn",
          end: "Ende",
          regular: "Regulär",
          overtime: "Überstunden",
          night: "Nacht",
        },
        totals: {
          regular: "Gesamt regulär",
          overtime: "Gesamt Überstunden",
          night: "Gesamt Nacht",
        },
        form: {
          startTime: "Beginn",
          endTime: "Ende",
          overtimeMinutes: "Überstunden",
          overtimeUnit: "Min",
          egPrefix: "z.B.",
          invalidTime: "Gültige Uhrzeit eingeben (00:00–23:59)",
          invalidOvertime: "Überstunden müssen eine nicht-negative Zahl sein",
          exceedsDailyFond: "Die eingegebene Arbeitszeit überschreitet das definierte Tagessoll des Mitarbeiters von {max} Stunden.",
          exceedsWeeklyRegular: "Diese Woche verbleiben nur noch {remaining} Std. reguläre Arbeitszeit (höchstens {max} Std. pro Woche). Tragen Sie den Rest als Überstunden ein.",
          weeklyRegularFull: "Das Wochensoll von {max} Std. regulärer Arbeitszeit ist erreicht — die gesamte Schicht wird als Überstunden erfasst.",
          saturdayOvertime: "Der gesamte Samstag wird als Überstunden erfasst; zusätzliche Stunden durch Verlängern der Arbeitszeit eintragen.",
          exceedsYearlyOvertime: "Die jährlichen Überstunden würden {total} Std. betragen, erlaubt sind höchstens {max} Std.",
          yearlyOvertimeWarning: "Die jährlichen Überstunden werden {total} Std. betragen. Die gesetzliche Jahresgrenze liegt bei {warning} Std., sofern ein Tarifvertrag nicht mehr vorsieht (höchstens {max} Std.).",
          editTitle: "Arbeitszeit-Eintrag",
        },
        actions: {
          edit: "Bearbeiten",
          save: "Speichern",
          cancel: "Abbrechen",
          delete: "Eintrag löschen",
          notWorked: "Nicht gearbeitet",
        },
        source: {
          MANUAL: "Manuell",
          PENDING: "Eingabe ausstehend",
        },
        toast: {
          saved: "Eintrag erfolgreich gespeichert",
          deleted: "Eintrag erfolgreich gelöscht",
        },
      },
    },
    nonTaxable: {
      title: "Steuerfreie Zuwendungen",
      type: "Art der Zuwendung",
      oneOffTitle: "Einmalige Auszahlung",
      paymentsTitle: "Auszahlungen",
      noPayments: "Für diese Art sind keine Auszahlungen erfasst.",
      amount: "Betrag (EUR)",
      payoutOption: "Auszahlungsart",
      uzPlacu: "Mit dem nächsten Gehalt",
      naDatum: "Zum Datum",
      payoutDate: "Auszahlungsdatum",
      submit: "Senden",
      confirm: "Bestätigen",
      downloadDecision: "Bescheid herunterladen",
      recurringAmount: "Fester monatlicher Betrag (EUR)",
      recurringNote: "Wird monatlich ausgezahlt, bis er geändert oder entfernt wird.",
      recurringValidFrom: "Gültig ab",
      recurringRemoval: "Entfernung des festen Betrags",
      recurringPending: "Wartet auf Genehmigung: {amount}",
      recurringPendingRemoval: "Entfernung wartet auf Genehmigung",
      recurringAction: {
        UPSERT: "Änderung",
        DELETE: "Entfernung",
      },
      remainingYear: "Verbleibend in diesem Jahr: {remaining} von {limit}",
      remainingMonth: "Verbleibend in diesem Monat: {remaining} von {limit}",
      usedThisYear: "In diesem Jahr ausgezahlt: {used} (keine gesetzliche Obergrenze)",
      usedThisMonth: "In diesem Monat ausgezahlt: {used} (bis zum tatsächlichen Ticketpreis)",
      previousEmployerMonth:
        "Davon hat der Mitarbeiter {amount} in diesem Monat bereits vom vorherigen Arbeitgeber erhalten.",
      previousEmployerYear:
        "Davon hat der Mitarbeiter {amount} in diesem Jahr bereits vom vorherigen Arbeitgeber erhalten.",
      emailNotice: "Sobald der Kunde die Auszahlung bestätigt, wird eine E-Mail an VOMI gesendet.",
      otherType: "Bezeichnung der Zuwendung",
      otherTypePlaceholder: "z. B. Jubiläumsprämie",
      types: {
        PRIJEVOZ: "Fahrtkosten",
        TOPLI_OBROK: "Verpflegungszuschuss",
        NAGRADA_ZA_RADNE_REZULTATE: "Leistungsprämie",
        PRIGODNA_NAGRADA: "Anlassprämie",
        OSTALO: "Sonstiges",
      },
      statuses: {
        PENDING_APPROVAL: "Wartet auf Genehmigung",
        DRAFT: "Wartet auf Unterschrift",
        CONFIRMED: "Bestätigt",
      },
      validation: {
        recurringRequired: "Geben Sie den monatlichen Betrag ein.",
        amountPositive: "Der Betrag muss größer als null sein.",
        amountOverLimit: "Der Betrag überschreitet das verbleibende Limit.",
        otherTypeRequired: "Die Bezeichnung der Zuwendung ist erforderlich.",
        payoutDateRequired: "Das Auszahlungsdatum ist erforderlich.",
      },
      toast: {
        created: "Auszahlung erfasst",
        confirmed: "Auszahlung bestätigt",
        recurringSaved: "Fester monatlicher Betrag gespeichert",
        recurringRemoved: "Fester monatlicher Betrag entfernt",
        recurringPending: "Antrag zur Genehmigung gesendet",
      },
    },
    absences: {
      title: "Abwesenheiten",
      subtitle: "Jahresurlaub, Krankmeldung und Langzeitabwesenheit",
      loading: "Laden...",
      toast: {
        created: "Antrag erstellt",
        confirmed: "Abwesenheit bestätigt",
        updated: "Abwesenheit aktualisiert",
        cancelled: "Abwesenheit storniert",
        deleted: "Antrag gelöscht",
        changeRequested: "Antrag wurde dem Master zur Genehmigung gesendet",
      },
      header: {
        vacationRemaining: "Verbleibende Urlaubstage",
        daysShort: "Tage",
        of: "von",
      },
      carryOver: {
        summary: "inkl. {days} {dayWord} übertragen aus {year}, zu nutzen bis {date}",
        detail: "Übertragen aus {year}: {days} {dayWord} — müssen bis {date} genutzt werden, sonst verfallen sie.",
        consumed: "Alle aus {year} übertragenen Tage ({days}) wurden genutzt.",
        expired: "{days} {dayWord} aus {year} wurden nicht bis {date} genutzt und sind verfallen.",
        overdue: "Die Frist {date} ist verstrichen und {days} {dayWord} aus {year} sind noch offen — bitte möglichst bald nehmen.",
      },
      tabs: {
        vacation: "Jahresurlaub",
        sickLeave: "Krankmeldung",
        longTermAbsence: "Langzeitabwesenheit",
        other: "Sonstiges",
      },
      type: {
        VACATION: "Jahresurlaub",
        SICK_LEAVE: "Krankmeldung",
        LONG_TERM_ABSENCE: "Langzeitabwesenheit",
        OTHER: "Sonstiges",
      },
      changeAction: {
        EDIT: "Änderung",
        EXTEND: "Verlängerung",
        CANCEL: "Stornierung",
      },
      status: {
        PENDING_APPROVAL: "Wartet auf Genehmigung",
        DRAFT: "In Vorbereitung",
        CONFIRMED: "Bestätigt",
        ACTIVE: "Aktiv",
        CANCELLED: "Storniert",
        // Derived on the client for a long-term absence whose end date has passed; not a stored status.
        ENDED: "Beendet",
      },
      actions: {
        submit: "Antrag senden",
        confirm: "Bestätigen",
        downloadPdf: "PDF herunterladen",
        cancel: "Stornieren",
        edit: "Bearbeiten",
        editEndDate: "Enddatum bearbeiten",
        extend: "Verlängern",
        save: "Speichern",
      },
      cancelConfirm: {
        title: "Antrag stornieren",
        message: "Möchten Sie den Urlaubsantrag für den Zeitraum vom {start} bis {end} stornieren?",
        accept: "Antrag stornieren",
        reject: "Abbrechen",
      },
      vacation: {
        startDate: "Startdatum",
        endDate: "Enddatum",
        legalBasis: "Rechtsgrundlage (optional)",
        remaining: "Verbleibend: {days} {dayWord}",
        note: "Wochenenden und Feiertage zählen nicht zum Jahresurlaub.",
        marked: "Ausgewählt: {marked} {dayWord}, verbleibend: {remaining}",
        budgetWarning: "Warnung: Sie überschreiten die verfügbaren Urlaubstage.",
        pickRange: "Wählen Sie einen Datumsbereich im Kalender",
        editTitle: "Urlaub bearbeiten",
      },
      sickLeave: {
        startDate: "Startdatum",
        endDate: "Enddatum (optional für offene Krankmeldung)",
        type: "Art der Krankmeldung",
        otherType: "Zusätzliche Erläuterung zur Art der Krankmeldung",
        otherTypePlaceholder: "Erläuterung eingeben",
        attachment: "Ärztliche Bescheinigung (PDF, JPEG oder PNG, max. 5 MB)",
        openHint: "Ein Klick = Wahl zwischen offener oder eintägiger Krankmeldung; zwei Klicks = Bereich.",
        openOption: "Offene Krankmeldung",
        singleDayOption: "Krankmeldung dauert nur einen Tag",
        editTitle: "Krankmeldung bearbeiten",
        extendTitle: "Krankmeldung verlängern",
        newEndDate: "Neues Enddatum (optional)",
        newAttachment: "Neue ärztliche Bescheinigung",
        salaryPercentage: "Vergütungsprozentsatz",
        salaryPercentageHint: "Das gesetzliche Minimum beträgt 70 % der Bemessungsgrundlage. Einen höheren Prozentsatz geben Sie an, wenn dieser im Arbeitsvertrag, in der Betriebsordnung oder im Tarifvertrag vereinbart ist.",
        types: {
          UP_TO_42_DAYS: "Bis 42 Tage (arbeitgeberfinanziert)",
          OVER_42_DAYS: "Über 42 Tage (HZZO-finanziert)",
          CHILD_CARE: "Kinderbetreuung",
          PREGNANCY_COMPLICATIONS: "Schwangerschaftskomplikationen",
          OCCUPATIONAL_INJURY: "Berufskrankheit / Arbeitsunfall",
          OSTALO: "Sonstiges",
        },
      },
      other: {
        reason: "Art der Abwesenheit angeben",
        reasonPlaceholder: "z. B. Eheschließung, Geburt eines Kindes oder Tod eines Familienmitglieds",
        hint: "Ein Klick = eintägige Abwesenheit; zwei Klicks = Zeitraum.",
        editTitle: "Abwesenheit bearbeiten",
      },
      longTermAbsence: {
        type: "Art der Langzeitabwesenheit",
        rangeHint: "Wählen Sie den Zeitraum im Kalender: der erste Klick ist das Startdatum, der zweite das Enddatum.",
        hint: "Während einer Langzeitabwesenheit ist der Mitarbeiter nicht in der Arbeitszeiterfassung — es werden keine Tageseinträge erzeugt und keine Stunden erwartet. Nach Ablauf des Zeitraums wird die Erfassung automatisch fortgesetzt.",
        masterOnly: "Nur ein Master kann eine Langzeitabwesenheit erfassen oder ändern.",
        editEndDateTitle: "Enddatum bearbeiten",
        editEndDateHint: "Ändern Sie das Enddatum für eine frühere oder spätere Rückkehr des Mitarbeiters.",
        newEndDate: "Neues Enddatum",
        types: {
          PREGNANCY_COMPLICATIONS: "Schwangerschaftskomplikationen",
          MATERNITY_LEAVE: "Mutterschaftsurlaub",
          PARENTAL_LEAVE: "Elternzeit",
          PATERNITY_LEAVE: "Vaterschaftsurlaub",
          ADOPTION_LEAVE: "Adoptionsurlaub",
          SEVERELY_DISABLED_CHILD_CARE: "Pflege eines Kindes mit schweren Entwicklungsstörungen",
          HALF_TIME_CHILD_CARE: "Halbtagsarbeit zur Kinderbetreuung",
          PAID_LEAVE: "Bezahlter Urlaub",
          UNPAID_LEAVE: "Unbezahlter Urlaub",
          EMPLOYMENT_SUSPENSION: "Ruhen des Arbeitsverhältnisses",
        },
      },
      list: {
        title: "Alle Abwesenheiten",
        empty: "Keine Abwesenheiten für diesen Mitarbeiter.",
        type: "Art",
        period: "Zeitraum",
        currentPeriod: "Aktueller Zeitraum",
        newPeriod: "Neuer Zeitraum",
        pendingChange: "Wartet auf Genehmigung: {action}",
        amount: "Betrag",
        status: "Status",
        actions: "Aktionen",
        open: "offen",
      },
      validation: {
        required: "Dieses Feld ist erforderlich",
        otherTypeRequired: "Dieses Feld ist erforderlich, wenn 'Sonstiges' ausgewählt ist",
        dateNotPast: "Das Datum darf nicht in der Vergangenheit liegen",
        endAfterStart: "Das Enddatum darf nicht vor dem Startdatum liegen",
        attachmentRequired: "Ärztliche Bescheinigung ist erforderlich",
        overlap: "Der Zeitraum überschneidet sich mit einer bestehenden Abwesenheit des Mitarbeiters.",
        startBeforeEmployment: "Das Datum darf nicht vor dem Eintrittsdatum des Mitarbeiters liegen",
        startBeforeRegistration: "Das Beginndatum der Abwesenheit darf nicht vor dem Anmeldedatum des Mitarbeiters liegen.",
      },
    },
    termination: {
      title: "Mitarbeiter abmelden",
      submit: "Abmeldung senden",
      warning: "Diese Aktion ist endgültig. Der Mitarbeiter bleibt aktiv, bis VOMI die Abmeldung bestätigt.",
      confirmTitle: "Abmeldung bestätigen",
      confirmMessage: "Möchten Sie die Abmeldung des Mitarbeiters wirklich einreichen?",
      confirmAccept: "Ja, abmelden",
      confirmReject: "Abbrechen",
      success: "Abmeldung gesendet — der Mitarbeiter bleibt aktiv, bis VOMI bestätigt.",
      pendingApproval: "Abmeldung zur Master-Genehmigung gesendet.",
      type: "Art der Beendigung",
      date: "Beendigungsdatum",
      noticePeriodType: "Art der Kündigungsfrist",
      noticePeriodDays: "Tage der Kündigungsfrist",
      vacationUsed: "Wurde der Jahresurlaub genommen?",
      unusedVacationDays: "Nicht genommene Urlaubstage",
      vacationPreview: "Am {date} verbleiben dem Mitarbeiter noch {days} {dayWord} Urlaub.",
      vacationPreviewError: "Der verbleibende Urlaub für das gewählte Datum konnte nicht berechnet werden.",
      unusedVacationOption: "Option für nicht genommenen Urlaub",
      daysToUse: "Tage zum Nehmen",
      daysToPayout: "Tage zur Auszahlung",
      misconductOptions: "Pflichtverletzungen",
      misconductDescription: "Beschreibung der Verletzung",
      attachment: "Anhang (PDF, JPEG oder PNG, max. 5 MB)",
      types: {
        MUTUAL_AGREEMENT: "Einvernehmliche Auflösung",
        FIXED_TERM_EXPIRY: "Ablauf des befristeten Vertrags",
        EMPLOYEE_INITIATED: "Kündigung durch Arbeitnehmer",
        PROBATIONARY_FAILURE: "Nichtbestehen der Probezeit",
        WORK_PERMIT_LOSS: "Verlust der Arbeitserlaubnis",
        BUSINESS_REASONS_EMPLOYER: "Betriebsbedingte Kündigung",
        EXTRAORDINARY_TERMINATION_EMPLOYEE: "Außerordentliche Kündigung durch Arbeitnehmer",
        EXTRAORDINARY_TERMINATION_EMPLOYER: "Außerordentliche Kündigung durch Arbeitgeber",
        EMPLOYEE_MISCONDUCT_REGULAR: "Ordentliche verhaltensbedingte Kündigung",
        RETIREMENT: "Eintritt in den Ruhestand",
        DEATH: "Tod des Arbeitnehmers",
      },
      noticePeriodTypes: {
        LEGAL: "Gesetzlich",
        AGREED: "Vereinbart",
      },
      vacationOptions: {
        USE_IN_NOTICE_PERIOD: "Während der Kündigungsfrist nehmen",
        PAYOUT: "Auszahlen",
        COMBINATION: "Kombination",
      },
      misconductTypes: {
        UNAUTHORIZED_ABSENCE: "Unentschuldigtes Fernbleiben von der Arbeit",
        REPEATED_VIOLATIONS: "Wiederholte Pflichtverletzungen",
        REFUSAL_OF_WORK: "Arbeitsverweigerung",
        INTOXICATION: "Arbeit unter Einfluss von Alkohol/Drogen",
        THEFT_OR_DAMAGE: "Diebstahl oder Schadenszufügung",
        BREACH_OF_CONFIDENTIALITY: "Verletzung der Vertraulichkeit",
        OTHER: "Sonstiges",
      },
      validation: {
        required: "Dieses Feld ist erforderlich",
        combinationSum: "Tage zum Nehmen und zur Auszahlung müssen der Anzahl der nicht genommenen Tage entsprechen.",
        attachmentRequired: "Für diese Beendigungsart ist ein Anhang erforderlich",
        attachmentTooLarge: "Datei ist zu groß (max. 5 MB)",
        dateOutOfRange: "Das Beendigungsdatum muss gestern (bis 14 Uhr), heute oder später sein, maximal 30 Tage im Voraus.",
      },
      resolution: {
        title: "Kündigungsbescheid",
        inProgress: "Abmeldung in Bearbeitung",
        waiting: "Abmeldung gesendet — VOMI erstellt den Bescheid. Das Dokument erscheint hier, sobald es bereit ist.",
        subtitle: "Prüfen Sie den Bescheid und unterschreiben Sie ihn digital.",
        download: "Herunterladen",
        confirm: "Dokument unterschreiben",
        confirmedBadge: "Unterschrieben",
        confirmHint: "Das unterschriebene Dokument steht zum Herunterladen und zur Übergabe an den Arbeitnehmer bereit.",
        confirmSuccess: "Dokument unterschrieben",
        downloadError: "Fehler beim Herunterladen des Bescheids",
        confirmError: "Fehler beim Unterschreiben des Dokuments",
      },
    },
    messages: {
      created: "Mitarbeiter erfolgreich erstellt",
      updated: "Mitarbeiter erfolgreich aktualisiert",
      deactivated: "Mitarbeiter erfolgreich deaktiviert",
      terminated: "Abmeldung des Mitarbeiters erfolgreich gesendet",
      archived: "Mitarbeiter erfolgreich archiviert",
      requestSent: "Die Anfrage zum Hinzufügen des Mitarbeiters wurde erfolgreich gesendet. Der Vorgang wird nach der Genehmigung durch den Master abgeschlossen.",
      documentsMissing: "Dokumente nicht gesendet",
      bulkImported: "Per Massenimport importiert",
      bulkImportedDocumentsReadonly: "Dieser Mitarbeiter wurde per Massenimport hinzugefügt. Die Dokumente sind bereits im Archiv verfügbar und können hier nicht bearbeitet werden.",
    },
  },
  notifications: {
    title: "Benachrichtigungen",
    taskStarted: "VOMI hat die Bearbeitung begonnen",
    documentReady: "Dokument bereit zur Unterschrift",
    taskCompleted: "Vorgang abgeschlossen",
    employeeImportCompleted: "Mitarbeiterimport abgeschlossen",
    employeeImportUndone: "Mitarbeiterimport rückgängig gemacht",
    reportReady: "Jahresabschluss zur Unterschrift bereit",
    contractExpiring: "Befristeter Vertrag läuft bald aus",
    employeeNoteReminder: "Erinnerung für Mitarbeiter",
    approvalApproved: "Hinzufügen des Mitarbeiters genehmigt",
    approvalRejected: "Hinzufügen des Mitarbeiters nicht genehmigt",
    approvalRejectedReason: "Grund: {reason}",
    employeeHardDeleted: "Vorgang und Mitarbeiter in Vorbereitung gelöscht",
    employeeHardDeletedBody: "Der Vorgang „{action}“ und der Mitarbeiter in Vorbereitung {name} wurden endgültig gelöscht.",
    employeeHardDeletedMessage: "Nachricht des Vomi-Benutzers: {message}",
    contractExpiringNote: "Vertrag endet am {date}. Dies ist das natürliche Ende des Vertrags, keine Abmeldeanfrage — bitte entscheiden Sie, ob Sie ihn verlängern oder den Mitarbeiter abmelden möchten.",
    importSummary: "VOMI hat {n} Mitarbeiter importiert",
    employeeCreatedByVomi: "Neuer Mitarbeiter angelegt",
    employeeCreatedByVomiBody: "Für Ihr Unternehmen wurde ein neuer Mitarbeiter, {name}, angelegt. Die Mitarbeiterdaten sind im Modul Mitarbeiter verfügbar.",
    employeeCreatedByVomiWorkStart: " Arbeitsbeginn: {date}.",
    importFailedSuffix: "{n} fehlgeschlagen",
    importUndoneSummary: "VOMI hat den Import rückgängig gemacht — {n} Mitarbeiter wurden entfernt",
    openToConfirm: "Zum Herunterladen und Bestätigen öffnen",
    employeeCorrected: "Mitarbeiterdaten korrigiert",
    employeeDeleted: "Mitarbeiter entfernt",
    correctedFieldsNote: "Geänderte Felder: {fields}. Durchgeführt von: {performedBy}.",
    deletedNote: "OIB {oib}. Durchgeführt von: {performedBy}.",
    actionPrijava: "Anmeldung",
    actionPromjena: "Änderung",
    actionOdjava: "Abmeldung",
  },
  approvals: {
    title: "Genehmigungsanfragen",
    pendingTitle: "Ausstehende Anfragen",
    noApprovals: "Keine ausstehenden Anfragen",
    approve: "Genehmigen",
    reject: "Ablehnen",
    confirmReject: "Ablehnung bestätigen",
    rejectionReason: "Grund",
    rejectionReasonPlaceholder: "Grund der Ablehnung eingeben...",
    approved: "Anfrage genehmigt",
    rejected: "Anfrage abgelehnt",
    alreadyDecided: "Diese Anfrage wurde bereits bearbeitet.",
    newPending: "Neue Genehmigungsanfrage",
    actionCreate: "Anmeldung",
    actionUpdate: "Änderung",
    actionDelete: "Abmeldung",
    proposedData: "Vorgeschlagene Daten",
    currentData: "Aktuelle Daten",
    field: "Feld",
    before: "Vorher",
    after: "Nachher",
    employee: "Mitarbeiter",
    action: "Aktion",
    requestedAt: "Angefragt am",
    contract: {
      title: "Vertragsbedingungen",
      jobTitle: "Position",
      workingHours: "Arbeitsstunden",
      vacationDays: "Urlaubstage",
      salary: "Bruttogehalt",
      desiredNetSalary: "Gewünschtes Nettogehalt",
      workLocation: "Arbeitsort",
      period: "Laufzeit",
    },
    termination: {
      title: "Kündigungsbedingungen",
      type: "Art",
      date: "Kündigungsdatum",
      noticeDays: "Kündigungsfrist (Tage)",
      unusedVacation: "Nicht genommener Urlaub",
      reason: "Begründung",
    },
  },
  dashboard: {
    notification: {
      title: "Benachrichtigungen",
      message:
        "Willkommen zur neuen Version der Vomi-App! Jetzt können Sie Mitarbeiter und Gehaltsabrechnungen einfacher verwalten. Das neue Modul für digitale Berichte ist jetzt verfügbar!",
    },
    employees: {
      label: "Mitarbeiter",
      active: "Aktiv",
    },
    payroll: {
      label: "Nächste Gehaltszahlung",
      notScheduled: "Nicht geplant",
    },
    recentActivity: {
      title: "Letzte Aktivität",
      newEmployee: "Neuer Mitarbeiter hinzugefügt",
      payrollCreated: "Gehaltsabrechnung erstellt",
      timesheetUpdated: "Zeiterfassung aktualisiert",
      daysAgo: "Tagen",
      noActivity: "Keine aktuelle Aktivität",
    },
  },
  payrollPage: {
    title: "Gehalt",
    periodLabel: "Zeitraum",
    loading: "Wird geladen...",
    error: "Gehaltsdaten konnten nicht geladen werden.",
    retry: "Erneut versuchen",
    status: {
      title: "Abrechnungsstatus",
      month: "Abrechnungsmonat",
      expectedPaymentDate: "Gewünschtes Auszahlungsdatum",
      label: "Status",
      notScheduled: "Noch nicht geplant",
      TODO: "Angefordert",
      IN_PROGRESS: "In Bearbeitung",
      DONE: "Abgeschlossen",
    },
    hours: {
      title: "Arbeitsstunden",
      completeMessage: "Alle Mitarbeiter haben ihre Stunden erfasst.",
      incompleteMessage: "Folgende Mitarbeiter haben ihre Stunden für diesen Monat noch nicht erfasst:",
      goToEmployee: "Mitarbeiter öffnen",
    },
    decisions: {
      title: "Unbestätigte Entscheidungen",
      noneMessage: "Für diesen Monat gibt es keine unbestätigten Entscheidungen.",
      pendingMessage: "Für den ausgewählten Monat gibt es noch nicht bestätigte Entscheidungen. Bitte bestätigen oder stornieren Sie diese, bevor Sie die Lohnabrechnung planen.",
      from: "ab",
      types: {
        VACATION: "Jahresurlaub",
        SICK_LEAVE: "Krankenstand",
        LONG_TERM_ABSENCE: "Langzeitabwesenheit",
        OTHER: "Sonstige Abwesenheit",
        REGISTRATION: "Anmeldung des Mitarbeiters",
        CONTRACT_CHANGE: "Vertragsänderung",
        TERMINATION: "Abmeldung des Mitarbeiters",
      },
    },
    schedule: {
      title: "Abrechnung planen",
      dateLabel: "Gewünschtes Auszahlungsdatum",
      submit: "Abrechnung einplanen",
      resubmit: "Datum ändern",
      blockedMessage: "Die Planung ist erst möglich, wenn alle Mitarbeiterstunden erfasst sind.",
      paymentDeadlineWarning:
        "Nach dem kroatischen Arbeitsgesetz muss das Gehalt für den Vormonat bis zum 15. Tag des Monats ausgezahlt werden, sofern der Arbeits- oder Tarifvertrag nichts anderes bestimmt.",
      lockedMessage: "Arbeitszeiten und das Datum der Lohnabrechnung können nicht bearbeitet werden, da die Lohnabrechnung in Bearbeitung oder abgeschlossen ist. Für Änderungen wenden Sie sich bitte an die Vomi d.o.o.",
      toast: {
        scheduled: "Abrechnung erfolgreich geplant.",
      },
    },
  },
  hoursPage: {
    title: "Stunden",
    periodLabel: "Zeitraum",
    sortLabel: "Nachname",
    sortAsc: "A–Z",
    sortDesc: "Z–A",
    searchPlaceholder: "Mitarbeiter suchen…",
    noSearchResults: "Keine Treffer für die Suche.",
    error: "Arbeitszeitdaten konnten nicht geladen werden.",
    retry: "Erneut versuchen",
    lockedMessage: "Arbeitszeiten und das Datum der Lohnabrechnung können nicht bearbeitet werden, da die Lohnabrechnung in Bearbeitung oder abgeschlossen ist. Für Änderungen wenden Sie sich bitte an die Vomi d.o.o.",
    empty: "Keine Daten für den ausgewählten Zeitraum.",
    columns: {
      name: "Vor- und Nachname",
      regular: "Regulär",
      overtime: "Überstunden",
      night: "Nacht",
      vacation: "Urlaub (Tage)",
      sickLeave: "Krankheit (Tage)",
      workingDays: "Arbeitstage",
      nonWorkingDays: "Arbeitsfreie Tage",
    },
    groups: {
      hours: "Stunden",
      days: "Tage",
    },
    labels: {
      regular: "Regulär",
      overtime: "Überstunden",
      night: "Nacht",
      vacation: "Urlaub",
      sickLeave: "Krankheit",
      working: "Arbeitstage",
      nonWorking: "Arbeitsfrei",
    },
  },
  reports: {
    title: "Berichte",
    subtitle: "Prüfen und unterschreiben Sie Ihre Berichte digital.",
    empty: "Noch keine Berichte verfügbar.",
    yearTabLabel: "Jahresabschlüsse für {year}",
    searchPlaceholder: "Berichte durchsuchen…",
    noSearchResults: "Keine Berichte entsprechen Ihrer Suche.",
    download: "Herunterladen",
    sign: "Dokument unterschreiben",
    statusSigned: "Unterschrieben",
    statusUnsigned: "Nicht unterschrieben",
    signSuccess: "Dokument unterschrieben",
    signError: "Fehler beim Unterschreiben des Dokuments",
    downloadError: "Fehler beim Herunterladen des Berichts",
    loadError: "Fehler beim Laden der Berichte",
    signatureRequired: "Richten Sie eine digitale Signatur in Ihrem Profil ein, um Berichte zu unterschreiben.",
    businessType: {
      llc: "GmbH",
      craft: "Gewerbe",
      association: "Verein",
    },
  },
};
